const NS = 'CourseAssessmentPage';
const CLS = 'courseAssessmentPage';

import { scrollTo } from 'scroll-js';

import { fixedScrollMixinPage } from '../../../pages/mixins/fixedScrollMixinPage/fixedScrollMixinPage';

export class CourseAssessmentPage {
    constructor(element) {
        this.element = element;
        this.$element = $(this.element);
        this.$courseAssessmentSectionNavigatorWidget = this.$element.find('[data-wg="CourseAssessmentSectionNavigatorWidget"]');
        this.$tplScroller = $('.tpl-scroller');
        this.$siteSubheaderCourseAssessmentWidget = $('.siteSubheaderCourseAssessmentWidget');

        this.scrollDuration = 750;
        this.scrollEasing = 'ease-in-out';
        this.$quizBlocks = this.$element.find('.FormStep').children('.FormChoice').children('[class*="Block"]');
        this.$sections = this.$element.find('.Form__Element.FormStep');
        this.$form = this.$element.find('form');

        this.sectionActiveIndex = +this.$element.find(`[name="__FormCurrentStepIndex"]`).val();
        if(_.isNil(this.sectionActiveIndex)) {
            this.sectionActiveIndex = 0;
        }

        this.initFixedScroll(this.sectionActiveIndex);
        this.initAttemptedQuestions();

        this.initPagination();
    }

    initFixedScroll(activeIndex) {
        let blocks = this.$sections.eq(activeIndex).children('.FormChoice').children('[class*="Block"]').toArray();
        let $submitBlock = this.$element.find(`.${CLS}-submit`);
        if($submitBlock.length > 0) {
            blocks.push($submitBlock[0]);
        }
        this.initFixedScrollMixin(this, blocks);
    }

    initAttemptedQuestions() {
        $(document).ready(() => {
            if(this.$quizBlocks && this.$quizBlocks.length > 0) {
                let attemptedQuestions = 0;

                this.$quizBlocks.each((index, element) => {
                    let $element = $(element);

                    // Increments the attempted questions and mark it as attempted
                    let incrementAttemptedQuestions = () => {
                        if($element.attr('data-quiz-attempted') !== 'true') {
                            $element.attr('data-quiz-attempted', true);
                            this.$siteSubheaderCourseAssessmentWidget.trigger('siteSubheaderCourseAssessmentWidget.quizzes.increment', {});
                        }
                    };

                    let $multiChoiceAnswerBlock = $element.find('.multiChoiceAnswerBlock');
                    $multiChoiceAnswerBlock.on('click', () => {
                        incrementAttemptedQuestions();
                    });

                    let $imageSelectAnswerBlock = $element.find('.imageSelectAnswerBlock');
                    $imageSelectAnswerBlock.on('click', () => {
                        incrementAttemptedQuestions();
                    });

                    // Check if there are items already checked in the quiz block
                    let $checkedItems = $element.find(`input[checked=checked]`);
                    if($checkedItems && $checkedItems.length > 0) {
                        // Quiz has already been attempted
                        $element.attr('data-quiz-attempted', true);
                        attemptedQuestions++;
                    }
                });

                // Deal with setting the intial values
                this.$siteSubheaderCourseAssessmentWidget.trigger('siteSubheaderCourseAssessmentWidget.quizzes.init', {
                    totalQuestions: this.$quizBlocks.length,
                    attemptedQuestions: attemptedQuestions
                });
            }
        });
    }

    initPagination() {
        this.$element.find(`.${CLS}-pagination .page-link--previous`).on('click', () => {
            let previous = this.sectionActiveIndex - 1;
            if(previous >= 0) {
                this.setActiveSection(previous);
            }
        });

        this.$element.find(`.${CLS}-pagination .page-link--next`).on('click', () => {
            let next = this.sectionActiveIndex + 1;
            if(next <= (this.$sections.length - 1)) {
                this.setActiveSection(next);
            }
        });
    }

    setActiveSection(activeIndex) {
        this.$courseAssessmentSectionNavigatorWidget.trigger('courseAssessmentSectionNavigatorWidget.activeNavigationSectionIndex.changed', {
            activeNavigationSectionIndex: activeIndex
        });

        this.$element.find('.pagination .page-item')
            .not('.page-item--previous')
            .not('.page-item--next')
            .removeClass('active')
            .eq(activeIndex)
            .addClass('active');

        this.initFixedScroll(activeIndex);
        this.sectionActiveIndex = activeIndex;        
        scrollTo(this.$tplScroller[0], { top: 0, duration: this.scrollDuration, easing: this.scrollEasing });
    }
}

Object.assign(CourseAssessmentPage.prototype, fixedScrollMixinPage);